import { FC } from 'react'

import { ISvgClass } from '../interface'

const ShoppingCartPlusIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      width="24px"
      height="24px"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="inherit"
        stroke="none"
      >
        <path d="M414 4521 c-61 -28 -89 -73 -89 -143 0 -61 17 -94 69 -132 26 -20 44 -21 318 -26 l291 -5 303 -1122 c166 -616 310 -1135 319 -1151 10 -17 35 -40 55 -51 l38 -21 1278 0 c1259 0 1280 0 1312 20 18 11 41 34 51 51 11 18 53 168 95 334 84 338 84 349 23 413 -58 60 -150 65 -212 11 -43 -38 -48 -53 -109 -296 l-52 -208 -1111 -3 -1112 -2 -15 52 c-25 90 -116 435 -116 441 0 4 441 7 981 7 1096 0 1026 -5 1076 71 55 83 15 202 -80 238 -19 8 -350 11 -1047 11 l-1019 0 -15 53 c-25 88 -116 433 -116 440 0 4 375 8 834 9 831 3 835 3 863 24 71 53 88 154 38 219 -57 76 21 70 -952 73 l-872 2 -11 38 c-5 20 -42 156 -82 301 -72 265 -89 306 -141 345 -27 20 -41 21 -390 24 -337 2 -365 1 -403 -17z" />
        <path d="M4120 4198 c-61 -42 -70 -73 -70 -250 l0 -158 -158 0 c-134 0 -162 -3 -192 -19 -91 -48 -112 -170 -43 -243 47 -51 77 -58 243 -58 l150 0 0 -159 c0 -148 1 -160 23 -192 38 -57 84 -81 143 -77 64 5 110 37 135 92 15 34 19 66 19 189 l0 147 148 0 c122 0 154 4 188 19 61 28 89 73 89 143 0 63 -19 97 -75 136 -31 20 -44 22 -191 22 l-157 0 -4 163 c-3 161 -3 164 -31 200 -15 21 -41 44 -57 52 -44 23 -121 19 -160 -7z" />
        <path d="M2283 1686 c-189 -46 -359 -213 -408 -401 -19 -75 -19 -213 0 -285 54 -203 222 -361 430 -405 88 -18 132 -18 220 0 207 43 377 202 430 401 21 78 21 219 0 291 -43 146 -157 288 -282 352 -116 58 -268 76 -390 47z m209 -318 c53 -16 122 -79 143 -130 27 -67 22 -147 -11 -209 -119 -218 -444 -134 -444 115 0 164 151 272 312 224z" />
        <path d="M3746 1684 c-344 -83 -522 -471 -365 -794 43 -88 160 -203 249 -247 228 -109 464 -71 641 106 181 181 220 427 102 655 -116 223 -378 340 -627 280z m260 -340 c157 -97 147 -329 -20 -417 -56 -29 -155 -29 -211 0 -180 94 -175 349 9 435 63 29 159 21 222 -18z" />
      </g>
    </svg>
  )
}

export default ShoppingCartPlusIcon
